<ng-template #priceEntriesBlockUi>
    <p-button
        [pTooltip]="
            !checkIfCanSave()
                ? ('address.save-address-first' | translate)
                : ('address.missing-data-for-save' | translate)
        "
        [loading]="isSaving()"
        icon="fa fa-save"
        [label]="'address.save-address-first' | translate"
        [disabled]="checkIfCanSave()"
        (onClick)="saveToUnlockEditMode()"
    ></p-button>
</ng-template>

<blockable-div
    #priceEntriesBlock
    [class]="'w-full'"
    [blocked]="!model?.id"
    [blockUi]="priceEntriesBlockUi"
>
    @if (model?.id) {
        <app-price-list-entry-list-widget
            #priceListEntryListWidget
            [autoFocusSearch]="false"
            [fillHeightList]="false"
            [listType]="customerAddressId() ? PriceListType.CUSTOMER : PriceListType.VENDOR"
            [product]="product()"
            [debitorAddressId]="customerAddressId()"
            [creditorAddressId]="vendorAddressId()"
            [debitorIdentifier]="debitorIdentifier()"
            [creditorIdentifier]="creditorIdentifier()"
            [viewName]="customerAddressId() ? 'CustomerPriceListEntry' : 'VendorPriceListEntry'"
            [paginator]="true"
            [showActiveAndHistorySwitch]="props.showActiveAndHistorySwitch"
        />
    }
</blockable-div>
